// reducers/streamCountReducer.js
import { UPDATE_STREAM_COUNT, SET_STREAM_COUNT } from "../action/streamCount";

const initialState = {
  streamCount: 0,
};

export default function streamCountReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_STREAM_COUNT:
      // Add the partial increment
      return {
        ...state,
        streamCount: state.streamCount + action.payload,
      };

    case SET_STREAM_COUNT:
      // Overwrite the entire total
      return {
        ...state,
        streamCount: action.payload,
      };

    default:
      return state;
  }
}
